import { DownOutlined, UpOutlined } from "@ant-design/icons"
import { useEffect, useState } from "react"
import { getColumns } from "./model"
import { CustomDynamicTable } from "../../../../../../components/custom/customDynamicTable"
import { Form } from "antd"


interface IProps {
    initProgramTicketList: IProgramTicket[]
    setProgramTicketList: React.Dispatch<React.SetStateAction<IProgramTicket[]>>
    isDefalutOpen?: boolean
}

const groundValue: IEditProgramTicket = {
    id: 0,
    name: '',
    description: '',
    payAmount: 0,
    isEdit: true
}

const ProgramTicketSetting = ({ initProgramTicketList, setProgramTicketList, isDefalutOpen = false }: IProps) => {
    const [isBookingSettingOpen, setIsBookingSettingOpen] = useState<boolean>(isDefalutOpen)
    const [editProgramTicketList, setEditProgramTicketList] = useState<IEditProgramTicket[]>(initProgramTicketList?.map(q => ({ ...q, isEdit: false })) ?? [])

    useEffect(() => {
        editProgramTicketList && setProgramTicketList(editProgramTicketList.map(ticket => {
            const { isEdit, ...rest } = ticket;
            return { ...rest };
        }))
    }, [editProgramTicketList])

    return <>
        <div style={{ display: 'flex', justifyContent: 'space-between', cursor: 'pointer' }} onClick={_ => setIsBookingSettingOpen(q => !q)}>
            <div style={{ fontSize: '20px', fontWeight: 600, paddingBlock: '20px' }}>
                티켓 설정
                <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.isPaid !== currentValues.isPaid}>
                    {({ getFieldValue }) =>
                        getFieldValue('isPaid') && <span style={{ color: 'var(--ant-color-error)' }}>*</span>}
                </Form.Item>
            </div>
            {isBookingSettingOpen
                ? <DownOutlined />
                : <UpOutlined />}
        </div>
        <div style={{ position: 'relative', height: '1px' }}>
            <div style={{ position: 'absolute', left: '-20px', width: 'calc(100% + 40px)', height: '1px', backgroundColor: 'var(--ant-layout-footer-bg)' }} />
        </div>
        <div style={{ transition: 'max-height 0.3s ease, margin-block 0.4s ease', maxHeight: isBookingSettingOpen ? '100vh' : '0', overflow: 'hidden', marginBlock: isBookingSettingOpen ? '24px' : '0' }}>
            <CustomDynamicTable groundValue={groundValue} dataList={editProgramTicketList} setDataList={setEditProgramTicketList} getColumns={getColumns} footerText="+ 티켓 추가" />
        </div>
    </>
}

export { ProgramTicketSetting }